import API from "../../../../api/axiosClient";

 
const baseUrl = "Chat";

const sendMessage = async (data: any) => {

    const response = await API.post(
        `${baseUrl}/message`,
        data
    );

    return response.data;

};

const getMessages = async (groupId: string) => {

    const response = await API.get(
        `${baseUrl}/group/${groupId}`
    );

    return response.data;

};

const editMessage = async (
    messageId: string,
    message: string
) => {

    await API.put(
        `${baseUrl}/${messageId}`,
        {
            message
        }
    );

};

const deleteMessage = async (
    messageId: string
) => {

    await API.delete(
        `${baseUrl}/${messageId}`
    );

};

const ChatService = {

    sendMessage,
    getMessages,
    editMessage,
    deleteMessage

};

export default ChatService;